import React from 'react';


export default function Weddings(){
    return (<div>
                <h1>this is information on weddingsand a small gallery!</h1>

    </div>
    );
}